// extracted by mini-css-extract-plugin
export var container = "_5a-0";
export var containerTopRight = "_5a-1";